import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "@arelia-components/layout/Header";
import { PATHS } from "../../routes";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import { getFansNavOptions, planSupportsMyFans } from "./constant";
import { ComingSoonScreen } from "@arelia-components/ui-atoms/ComingSoonScreen";
import Content from "@arelia-components/layout/Content";
import SettingsProcessSteps from "./settings/SettingsProcessSteps";
import { Box, Button, Typography } from "@mui/material";
import { useConfiguration } from "src/api/configuration";
import AppContext from "src/AppContext";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export default function Fans() {
  const { pathname } = useLocation();
  const { data: config } = useConfiguration();
  const navigate = useNavigate();
  const { account } = useContext(AppContext);
  const navOptions = getFansNavOptions(config?.flags || {}, account?.plan);
  const showMyFansContent = planSupportsMyFans(account?.plan);

  useEffect(() => {
    if (pathname === PATHS.FANS) {
      navigate(PATHS.FANS_DASHBOARD);
    }
  }, [pathname]);

  const handleUpgrade = () => {
    navigate("/account/subscription?changePlan=true");
  };

  return (
    <ContentBox>
      <Header
        title="My Fans"
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      {config?.flags.EnableMyFans
        ? <>
          <Box sx={{ cursor: 'pointer' }}><SettingsProcessSteps clickEnabled={true} /></Box>
          {showMyFansContent 
            ? <Content /> 
            : (
              <Box sx={styles.upgradeContainer}>
                <Typography variant="h5" sx={styles.upgradeText}>
                  Your current subscription doesn't include My Fans features
                </Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  size="medium" 
                  startIcon={<AutoAwesomeIcon />}
                  onClick={handleUpgrade}
                  sx={styles.upgradeButton}
                >
                  Upgrade to Premium + My Fans
                </Button>
              </Box>
            )}
        </>
        : <ComingSoonScreen />
      }
    </ContentBox>
  );
}

const styles = {
  upgradeContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
    width: '100%',
    gap: '24px'
  },
  upgradeText: {
    textAlign: 'center',
    marginBottom: '16px',
    color: '#555'
  },
  upgradeButton: {
    padding: '12px 24px',
    fontSize: '16px'
  }
};
